import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { incrementValueLayer, decrementValueLayer } from '../actions/valueSet';
import style from './valueSquare.css';

class ValueSquare extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  render() {
    return (
      <div
        style={this.props.overrideStyle}
        className={this.props.canSelect ?
          (this.props.isSelected ?
          style.displaySquareSelected :
          style.displaySquareUnselected)
        :
          (this.props.isSelected ?
            style.displaySquareSelectedNoHover :
            style.displaySquareDisabled)}
        onClick={this.props.isSelected ?
          this.props.doUnselect :
          (this.props.canSelect ? this.props.doSelect : () => {})}
      >
        <div className={style.displayText}>
          {this.props.displayTitle}
        </div>
      </div>
    );
  }
}

// This is totally optional, but forces react to check the prop types
// when running in debug
ValueSquare.propTypes = {
  valueId: PropTypes.number.isRequired,
  displayTitle: PropTypes.string.isRequired,
  canSelect: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  doSelect: PropTypes.func.isRequired,
  doUnselect: PropTypes.func.isRequired,
  overrideStyle: PropTypes.object,
};


function mapStateToProps(state, props) {
  // const valueObject = state.valueHash[props.valueId];

  // return {
  //   displayTitle: valueObject.displayTitle,
  //  isSelected: valueObject.isSelected,
  // };
  return {};
}
function mapDispatchToProps(dispatch, props) {
  return {
    doSelect() {
      dispatch(incrementValueLayer(props.valueId));
    },
    doUnselect() {
      dispatch(decrementValueLayer(props.valueId));
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ValueSquare);



// WEBPACK FOOTER //
// ./src/components/valueSquare.js